export const ID = '4baea757-e369-41f2-ad3b-8e322078c854';

export const NAME = 'Directions: Show More/Less';
